import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutationTypes'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		menuList: [],
		token: null,
		expiration: null,
		userProjectRelation: null,
		// versions: '1.1.0',
		whiteYearMonth:null,
		whiteYearMonthName:null,
		whiteListIsOpen:null,
		supplementaryOpen:null,
		currentPhase:null,
		auditOpen:null,
		userInfo: null,
		meunuListChange:'NO',
		project:null,
		projectUrl:null,
		businessType:null,
		// projectWhiteEntity:null,
		supplementBatch:null,
		isOpenEditHistory:null,
		invoiceStart:null,
		invoiceEnd:null,
		invoiceRestrictionStart:null,
		invoiceRestrictionEnd:null,
		supplementBatchEntity:null,
		commonBatchEntity:null,
		privateKey:null,
		userRole: null
	},
	mutations: {
		[types.SET_MENU_LIST](state, status) {
			state.menuList = status
		},
		[types.SET_TOKEN](state, status) {
			state.token = status
		},
		[types.SET_EXPIRATION](state, status) {
			state.expiration = status
		},
		[types.SET_USER_PROJECT](state, status) {
			state.userProjectRelation = status
		},
		[types.SET_WHITE_YEAR_MONTH](state, status) {
			state.whiteYearMonth = status
		},
		[types.SET_WHITE_YEAR_MONTH_NAME](state, status) {
			state.whiteYearMonthName = status
		},
		[types.SET_WHITE_LIST_IS_OPEN](state, status) {
			state.whiteListIsOpen = status
		},
		[types.SET_WHITE_SUPPLEMENTARY_OPEN](state, status) {
			state.supplementaryOpen = status
		},
		[types.SET_CURRENT_PHASE](state, status) {
			state.currentPhase = status
		},
		[types.SET_AUDIT_OPEN](state, status) {
			state.auditOpen = status
		},
		[types.SET_USER_INFO](state, status) {
			state.userInfo = status
		},
		[types.SET_MENU_LIST_CHANGE](state, status) {
			state.meunuListChange = status
		},
		[types.SET_PROJECT](state, status) {
			state.project= status
		},
		[types.SET_PROJECT_URL](state, status) {
			state.projectUrl = status
		},
		[types.SET_BUSINESS_TYPE](state, status) {
			state.businessType = status
		},
		// [types.SET_PROJECT_WHITE_ENTITY](state, status) {
		// 	state.projectWhiteEntity = status
		// },
		[types.SET_IS_OPEN_EDIT_HISTORY](state, status) {
			state.isOpenEditHistory = status
		},
		[types.SET_SUPPLEMENT_BATCH](state, status) {
			state.supplementBatch = status
		},

		[types.SET_INVOICE_START](state, status) {
			state.invoiceStart = status
		},
		[types.SET_INVOICE_END](state, status) {
			state.invoiceEnd = status
		},
		[types.SET_INVOICE_RESTRICTION_START](state, status) {
			state.invoiceRestrictionStart = status
		},
		[types.SET_INVOICE_RESTRICTION_END](state, status) {
			state.invoiceRestrictionEnd = status
		},
		[types.SET_COMMON_BATCH_ENTITY](state, status) {
			state.commonBatchEntity = status
		},
		[types.SET_SUPPLEMENT_BATCH_ENTITY](state, status) {
			state.supplementBatchEntity = status
		},
		[types.SET_PRIVATEKEY](state, status) {
			state.privateKey = status
		},
		[types.SET_USER_ROLE](state, status) {
			state.userRole = status
		},
	},

	actions: {
		setMenuList(context, status) {
			context.commit(types.SET_MENU_LIST, status);
		},
		setToken(context, status) {
			context.commit(types.SET_TOKEN, status);
		},
		setExpiration(context, status) {
			context.commit(types.SET_EXPIRATION, status);
		},
		setUserProjectRelation(context, status) {
			context.commit(types.SET_USER_PROJECT, status);
		},
		setWhiteYearMonth(context, status) {
			context.commit(types.SET_WHITE_YEAR_MONTH, status);
		},
		setWhiteYearMonthName(context, status) {
			context.commit(types.SET_WHITE_YEAR_MONTH_NAME, status);
		},
		setWhiteListIsOpen(context, status) {
			context.commit(types.SET_WHITE_LIST_IS_OPEN, status);
		},
		setSupplementaryOpen(context, status) {
			context.commit(types.SET_WHITE_SUPPLEMENTARY_OPEN, status);
		},
		setCurrentPhase(context, status) {
			context.commit(types.SET_CURRENT_PHASE, status);
		},
		setAuditOpen(context, status) {
			context.commit(types.SET_AUDIT_OPEN, status);
		},
		setUserInfo(context, status) {
			context.commit(types.SET_USER_INFO, status);
		},
		setMenuListChange(context, status) {
			context.commit(types.SET_MENU_LIST_CHANGE, status);
		},
		setProject(context, status) {
			context.commit(types.SET_PROJECT, status);
		},
		setProjectUrl(context, status) {
			context.commit(types.SET_PROJECT_URL, status);
		},
		setBusinessType(context, status) {
			context.commit(types.SET_BUSINESS_TYPE, status);
		},
		// setProjectWhiteEntity(context, status) {
		// 	context.commit(types.SET_PROJECT_WHITE_ENTITY, status);
		// },
		setIsOpenEditHistory(context, status) {
			context.commit(types.SET_IS_OPEN_EDIT_HISTORY, status);
		},
		setSupplementBatch(context, status) {
			context.commit(types.SET_SUPPLEMENT_BATCH, status);
		},
		setInvoiceStart(context, status) {
			context.commit(types.SET_INVOICE_START, status);
		},
		setInvoiceEnd(context, status) {
			context.commit(types.SET_INVOICE_END, status);
		},
		setInvoiceRestrictionStart(context, status) {
			context.commit(types.SET_INVOICE_RESTRICTION_START, status);
		},
		setInvoiceRestrictionEnd(context, status) {
			context.commit(types.SET_INVOICE_RESTRICTION_END, status);
		},
		setSupplementBatchEntity(context, status) {
			context.commit(types.SET_SUPPLEMENT_BATCH_ENTITY, status);
		},
		setCommonBatchEntity(context, status) {
			context.commit(types.SET_COMMON_BATCH_ENTITY, status);
		},
		setPrivateKey(context, status) {
			context.commit(types.SET_PRIVATEKEY, status);
		},
		setUserRole(context, status) {
			context.commit(types.SET_USER_ROLE, status);
		},
	},
	getters: {
		menuList: state => state.menuList,
		token: state => state.token,
		expiration: state => state.expiration,
		userProjectRelation: state => state.userProjectRelation,
		whiteYearMonth: state => state.whiteYearMonth,
		whiteYearMonthName: state => state.whiteYearMonthName,
		whiteListIsOpen: state => state.whiteListIsOpen,
		supplementaryOpen: state => state.supplementaryOpen,
		currentPhase: state => state.currentPhase,
		auditOpen: state => state.auditOpen,
		userInfo: state => state.userInfo,
		menuListChange: state => state.meunuListChange,
		project: state => state.project,
		projectUrl: state => state.projectUrl,
		businessType: state => state.businessType,
		// projectWhiteEntity: state => state.projectWhiteEntity,
		supplementBatch:state => state.supplementBatch,
		isOpenEditHistory:state => state.isOpenEditHistory,
		invoiceStart:state => state.invoiceStart,
		invoiceEnd:state => state.invoiceEnd,
		invoiceRestrictionStart:state => state.invoiceRestrictionStart,
		invoiceRestrictionEnd:state => state.invoiceRestrictionEnd,
		supplementBatchEntity:state => state.supplementBatchEntity,
		commonBatchEntity:state => state.commonBatchEntity,
		privateKey:state => state.privateKey,
		userRole: state => state.userRole,
	}
})
